export default {
      id: "geometry-usage",
      viewBox: "0 0 32 32",
      url: __webpack_public_path__ + "sprite.svg#geometry-usage",
      toString: function () {
        return this.url;
      }
    }